export default function ServiceRow({ service, selected, onToggle }) {
  return (
    <div
      className="border rounded p-3 h-100 d-flex align-items-center justify-content-between"
      style={{
        backgroundColor: selected ? "#f0f6ff" : "#fff",
        boxShadow: selected ? "0 0 0 2px rgba(13,110,253,.2) inset" : "none",
        cursor: "pointer",
      }}
      onClick={() => onToggle(service.serviceID)}
    >
      <div className="d-flex align-items-center">
        {service.logoURL && (
          <img
            src={service.logoURL}
            alt={service.serviceCarrierName}
            style={{ width: 40, height: 40, objectFit: "contain", marginRight: 12 }}
          />
        )}
        <div className="fw-semibold text-dark">
          {service.serviceNameCustomer || service.serviceCarrierName}
        </div>
      </div>

      <input
        type="checkbox"
        checked={selected}
        onChange={() => onToggle(service.serviceID)}
        onClick={(e) => e.stopPropagation()}
        style={{ width: 18, height: 18 }}
      />
    </div>
  );
}
